export * as SystemIcon from './System/SystemIcon';
export * as ProductIcon from './Product/ProductIcon';
//# sourceMappingURL=index.js.map